import React, { useState } from "react";
import { Grid, Paper } from "@material-ui/core";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Button,
  Box,
  TableBody,
  TablePagination,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import moment from "moment";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import TableSkeleton from "../../../../StyledComponents/TableSkeleton";
import EmptyData from "../../../../StyledComponents/Table/EmptyData";
import "./style.css";
import Heading from "../../../../StyledComponents/Heading/Heading";
const useStyles = makeStyles({
  table: {
    minWidth: 650,
    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
  },
  inputStyle: {
    border: "none",
  },
});

function CommentHistory({ commentsList, commentsLoading }) {
  const classes = useStyles();

  const [page, setpage] = useState(0);
  const [RowsPerPage, setRowsPerPage] = useState(20);
  const [formState, setFormState] = useState({
    isAsc: false,
    OrderBy: "Comment Date", 
  });
  const [isOrderUpdated, setisOrderUpdated] = useState(true);

  const handleChangePage = (event, newPage) => {
    setpage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setpage(0);
  };

  const Sorting = (value) => {
    setisOrderUpdated(false);
    setFormState((formState) => ({
      ...formState,
      OrderBy: value,
    }));
  };

  const isAscending = (value) => {
    setFormState((formState) => ({
      ...formState,
      isAsc: value,
    }));
  };

  const sortedComments = [...commentsList].sort((a, b) => {
    const dateA = moment(b?.CommentDate);
    const dateB = moment(a?.CommentDate);
    if (formState.OrderBy === "Comment Date") {
      if (formState.isAsc) {
        return dateA.isBefore(dateB) ? -1 : 1;
      } else {
        return dateA.isBefore(dateB) ? 1 : -1;
      }
    }
    return 0;
  });

  return (
    <Grid container style={{ margin: "0px 0px", overflowY: "auto" }}>
      <Grid item xs={12} sm={12} md={12} lg={12} style={{ width: "0" }}>
        <Heading title="Comments History" />

        <TableContainer
          className="scrollable"
          style={{
            maxHeight: "400px",
            minHeight: "100px",
            overflowY: "auto",
          }}
        >
          <Table
            className={classes.table}
            aria-label="a dense table"
            size="small"
            sx={{
              height: 40,
            }}
          >
            <TableHead>
              <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  Comment By
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", color: "#031C30" }}
                  onClick={() => {
                    isAscending(!formState.isAsc);
                    Sorting("Comment Date");
                  }}
                >
                  <span className={classes.tableCell}>
                    {"Comment Date             "}
                    {formState.isAsc ? (
                      <ArrowUpwardIcon
                        className={`${formState.OrderBy === "Comment Date"
                          ? classes.iconButtonActive
                          : classes.iconButton
                        }`}
                      />
                    ) : (
                      <ArrowDownwardIcon
                        className={`${formState.OrderBy === "Comment Date"
                          ? classes.iconButtonActive
                          : classes.iconButton
                        }`}
                      />
                    )}
                  </span>
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  Activity Name
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    color: "#031C30",
                  }}
                >
                  Action Performed
                </TableCell>

                <TableCell
                  sx={{
                    fontWeight: "bold",
                    color: "#031C30",
                  }}
                >
                  Comment
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {commentsList?.length > 0 &&
                sortedComments
                  .slice(page * RowsPerPage, page * RowsPerPage + RowsPerPage)
                  .map((item) => {
                    return (
                      <TableRow key={item?.CommentId}>
                        <TableCell style={{ color: "black", height: "40px" }}>
                          {item?.CommentBy || item?.CommentedBy}
                        </TableCell>
                        <TableCell style={{ color: "black", width: "15%" }}>
                          {moment(item?.CommentDate).format("DD-MMM-YYYY")}
                        </TableCell>
                        <TableCell style={{ color: "black", width: "15%" }}>
                          {item?.ActivityName}
                        </TableCell>
                        <TableCell style={{ color: "black", width: "15%" }}>
                          {item?.ActionPerformed}
                        </TableCell>
                        <TableCell style={{ color: "black", width: "40%" }}>
                          {item?.CommentText}
                        </TableCell>
                      </TableRow>
                    );
                  })}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Grid sm={12} md={12} lg={12} style={{ width: "0" }}>
        {commentsList?.length === 0 ? <EmptyData /> : ""}
        <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={commentsList.length}
          rowsPerPage={RowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Grid>
    </Grid>
  );
}

export default CommentHistory;
